/**
 * Where a live lesson opens on a wide screen (decision 135): Lessons, with that lesson selected in the pane and
 * the list beside it, on the tab that holds it. The coach's Lessons is /orders, the player's /lessons; either
 * reads the lesson from the navigation's state (openLive), once. A phone keeps /live/:id, its page.
 */
export function lessonsTarget(p: { isCoach: boolean; bookingId: string; delivered: boolean }): { to: string; state: { openLive: string } } {
  return { to: `${p.isCoach ? '/orders' : '/lessons'}${p.delivered ? '?tab=delivered' : ''}`, state: { openLive: p.bookingId } };
}
